import { useEffect, useState } from "react";
import useLeadNotes from "../../hooks/useLeadNotes";
import LeadNoteEditor from "./LeadNoteEditor";
import LeadNotesList from "./LeadNotesList";
import LeadSelector from "./LeadSelector";

export default function LeadNotesManager({ leads }) {
  const [selectedLeadId, setSelectedLeadId] = useState("");
  const { addNote, notes, state } = useLeadNotes(selectedLeadId);

  useEffect(() => {
    if (!selectedLeadId && leads.length) setSelectedLeadId(leads[0].lead_id);
  }, [leads, selectedLeadId]);

  return (
    <section className="admin-section" data-testid="admin-lead-notes-manager">
      <div><span className="eyebrow">Relationship context</span><h2>INTERNAL LEAD NOTES</h2></div>
      {!leads.length && <div className="empty-state" data-testid="lead-notes-empty-leads-state">No leads are available for internal notes yet.</div>}
      {!!leads.length && <div className="lead-notes-layout"><LeadSelector leads={leads} selectedLeadId={selectedLeadId} onSelect={setSelectedLeadId} /><div className="lead-notes-panel"><LeadNotesList notes={notes} /><LeadNoteEditor onAddNote={addNote} state={state} /></div></div>}
    </section>
  );
}